import api from "./api.service";
import { adminTokenService } from "./admin.token.service";

export interface RatesReportRequest {
    startDate: string; // ISO String or YYYY-MM-DD
    endDate: string; // ISO String or YYYY-MM-DD
    detail: boolean;
}

export interface CarrierTotal {
    carrierId: number;
    carrierName: string;
    totalCarrier: number;
    tasa: number;
    pagarCarrier: number;
    totalGanancia: number;
    orderCount: number;
    orders?: { idOrder: number; tracking: string }[];
}

export interface RatesReportResponse {
    statusCode: number;
    message: string;
    data: CarrierTotal[];
}

class AdminReportService {
    async getRatesReport(request: RatesReportRequest): Promise<RatesReportResponse> {
        const token = adminTokenService.getAdminToken();
        try {
            const response = await api.post<RatesReportResponse>(
                "/admin/report/rates-report",
                request,
                {
                    headers: {
                        Authorization: `${token}`,
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching rates report:", error);
            throw error;
        }
    }

    async downloadRatesReportExcel(request: RatesReportRequest): Promise<Blob> {
        const token = adminTokenService.getAdminToken();
        try {
            const response = await api.post<Blob>(
                "/admin/report/rates-report-excel",
                request,
                {
                    headers: {
                        Authorization: `${token}`,
                    },
                    responseType: "blob",
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error downloading rates report excel:", error);
            throw error;
        }
    }
}

export const adminReportService = new AdminReportService();
